import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/minimal-responses']['GET'];
type Input = ThisApi['params'] & ThisApi['query'];

const getMinimalQuestionnaireResponses = async ({
  questionnaireId,
  lastUpdatedAt,
  deletedFromDate,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/minimal-responses', { questionnaireId });
  const data = await formsBackendClient.get(path, {
    params: { deletedFromDate, lastUpdatedAt },
  });
  return data.data;
};

export default getMinimalQuestionnaireResponses;
